'use strict';

/**
 * @typedef {String} ReportFormat
 */

export const ReportFormat = {
  /** @type {ReportFormat} */
  CSV: 'CSV',
  /** @type {ReportFormat} */
  XLSX: 'XLSX',
};



// WEBPACK FOOTER //
// ./src/js/core-utilities/enums/ReportFormat.js